import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@appkit4/angular-api';
import * as i2 from '@appkit4/angular-components/shared';

class TagComponent {
    constructor(el, render, localizationConfig, focusIndicatorService) {
        this.el = el;
        this.render = render;
        this.localizationConfig = localizationConfig;
        this.focusIndicatorService = focusIndicatorService;
        this.type = "filled";
        this.size = "small";
        // @Input() type: string = "blue";
        this.tabindex = "0";
        this.disabled = false;
        this.showClose = true;
        this.backgroundColor = '';
        this.fontColor = '';
        this.ariaLabel = '';
        this.onClose = new EventEmitter();
        this.inlineSytle = {};
        this.iconStyle = {};
        this.ispressed = false;
        this.ishover = false;
    }
    ngOnInit() {
        if (!this.inputId) {
            this.inputId = 'tag' + String.fromCharCode(65 + Math.floor(Math.random() * 26)) + Date.now();
        }
        // this.typeClass = 'ap-tag-' + this.type;
        this.setRelatedColor();
        // use backgroundColor to replace the type
        // if (this.backgroundColor) {
        //   Object.assign(this.inlineSytle, { backgroundColor: this.backgroundColor });
        // }
        // if (this.type === 'outlined') {
        //   Object.assign(this.inlineSytle, { backgroundColor: this.colorDetector(this.backgroundColor, .12) });
        // }
        // if (this.fontColor) {
        //   Object.assign(this.inlineSytle, { color: this.fontColor });
        //   Object.assign(this.iconStyle, { color: this.fontColor });
        //   if (this.type === 'outlined') {
        //     Object.assign(this.inlineSytle, { border: '1px solid ' + this.fontColor });
        //   }
        // }
        // if (this.disabled) {
        //   Object.assign(this.inlineSytle, { opacity: .32 });
        // } else {
        //   Object.assign(this.inlineSytle, { opacity: 1 });
        // }
    }
    ngAfterViewInit() {
        if (this.style) {
            if (typeof this.style === 'string') {
                this.el.nativeElement.querySelector('.ap-tag').style.cssText += this.style;
            }
            else {
                Object.assign(this.inlineSytle, this.style);
            }
        }
    }
    ngOnChanges(changes) {
        for (let propName in changes) {
            let change = changes[propName];
            if (propName === 'type') {
                this.type = change.currentValue;
                this.typeClass = 'ap-tag-' + this.type;
            }
            // Monitor the input value 'type'
            if (propName === 'type' && change.currentValue) {
                this.type = change.currentValue;
                this.setRelatedColor();
                // if (type === 'outlined') {
                // Object.assign(this.inlineSytle, { backgroundColor: this.colorDetector(this.backgroundColor, .12) });
                // } else {
                // Object.assign(this.inlineSytle, { backgroundColor: this.backgroundColor });
                // }
            }
            // Monitor the input value 'backgroundColor'
            if (propName === 'backgroundColor' && change.currentValue) {
                this.backgroundColor = change.currentValue;
                this.setRelatedColor();
                // if (this.disabled) {
                //   Object.assign(this.inlineSytle, { backgroundColor });
                // } else {
                //   Object.assign(this.inlineSytle, { backgroundColor });
                // }
            }
            // Monitor the input value 'fontColor'
            if (propName === 'fontColor' && change.currentValue) {
                this.fontColor = change.currentValue;
                this.setRelatedColor();
                // if (this.disabled) {
                //   Object.assign(this.inlineSytle, { color: fontColor, opacity: .32 });
                // } else {
                //   Object.assign(this.inlineSytle, { color: fontColor, opacity: 1});
                // }
                // Object.assign(this.iconStyle, { color: fontColor });
            }
            // Monitor the input value 'disabled'
            if (propName === 'disabled') {
                this.disabled = change.currentValue;
                this.setRelatedColor();
                // if (change.currentValue) {
                //   Object.assign(this.inlineSytle, { opacity: .32 });
                // } else {
                //   Object.assign(this.inlineSytle, { opacity: 1 });
                // }
            }
        }
    }
    colorDetector(color, alpha) {
        // color detctor and color convert
        // if color is hexcode, transform is as rgba
        // if color is rgb / rgba / text, continue
        const isHexcode = /^#([0-9a-f]{3}){1,2}$/i;
        if (color && isHexcode.test(color)) {
            return this.hexcodeToRgba(color, alpha);
        }
        else {
            return color;
        }
    }
    hexcodeToRgba(hex, alpha) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        // if hex code is #415385
        // result would be ["#415385", "41", "53", "85"]
        const r = parseInt(result[1], 16);
        const g = parseInt(result[2], 16);
        const b = parseInt(result[3], 16);
        return result ? `${r}, ${g}, ${b}` : null;
    }
    closeTag(event, text) {
        this.onClose.emit({
            originEvent: event,
            label: text
        });
    }
    onKeydown(event, text) {
        if (event.keyCode === 13) {
            if (event.target?.tagName === 'BUTTON') {
                this.onClose.emit({
                    originEvent: event,
                    label: text
                });
            }
            event.preventDefault();
        }
    }
    getAriaLabel(labelKey) {
        return this.localizationConfig.translation ? this.localizationConfig.translation[labelKey] : null;
    }
    ngOnDestroy() {
    }
    setRelatedColor() {
        let ele = this.el.nativeElement.firstChild;
        if (ele) {
            if (this.type === 'filled') {
                ele.style.setProperty('--tag-text-color', 'var(--color-text-tertiary)');
                ele.style.setProperty('--tag-icon-color', 'var(--color-text-tertiary)');
            }
            else {
                ele.style.setProperty('--tag-text-color', 'var(--color-text-primary)');
                ele.style.setProperty('--tag-icon-color', 'var(--color-text-primary)');
            }
            ele.style.setProperty('--tag-background-color', 'var(--color-background-primary-rgb)');
            ele.style.setProperty('--tag-border-color', 'var(--color-background-primary)');
            if (this.backgroundColor) {
                ele.style.setProperty('--tag-background-color', this.colorDetector(this.backgroundColor));
                ele.style.setProperty('--tag-border-color', this.backgroundColor);
            }
            if (this.fontColor) {
                ele.style.setProperty('--tag-text-color', this.fontColor);
                ele.style.setProperty('--tag-icon-color', this.fontColor);
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: TagComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i1.LocalizationConfig }, { token: i2.FocusIndicatorService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: TagComponent, selector: "ap-tag", inputs: { type: "type", size: "size", text: "text", tabindex: "tabindex", inputId: "inputId", disabled: "disabled", showClose: "showClose", styleClass: "styleClass", style: "style", backgroundColor: "backgroundColor", fontColor: "fontColor", ariaLabel: "ariaLabel" }, outputs: { onClose: "onClose" }, viewQueries: [{ propertyName: "apTag", first: true, predicate: ["apTag"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
              <div #apTag class="ap-tag ap-tag-default {{styleClass}}"
                  [attr.tabindex]="disabled || showClose ? -1 : tabindex"
                  [attr.disabled]="disabled"
                  [attr.aria-label]="text"
                  [attr.id]="inputId"
                  [attr.aria-label]="ariaLabel"
                  [attr.aria-disabled]="disabled"
                  [class.ap-tag-disabled]="disabled"
                  [ngClass]="{'ap-tag-sm':size==='small', 'ap-tag-lg':size==='large', 'ap-tag-outlined':type==='outlined','ap-tag-single':!showClose}"
                  [ngStyle]="inlineSytle"
                  (keydown)="onKeydown($event, text)"
              >
                <span [attr.title]="text" class="ap-tag-label"  *ngIf="text">{{ text }}</span>
                <button *ngIf="showClose" role="button" (click)="!disabled && closeTag($event, text)" type="button"  [attr.aria-description]="text" [attr.aria-label]="getAriaLabel('clear')" [attr.aria-disabled]="disabled" [disabled]="disabled" [style]="iconStyle" class="Appkit4-icon icon-circle-delete-fill"></button>
              </div>
            `, isInline: true, styles: [".ap-tag{position:relative;display:inline-block;padding:var(--spacing-2) var(--spacing-4);border-radius:1rem;line-height:1rem;letter-spacing:-.025rem;color:var(--color-text-tertiary);align-items:center;justify-content:space-between;-webkit-user-select:none;user-select:none}.ap-tag:after{border-radius:1rem}.ap-tag.ap-tag-disabled{cursor:not-allowed;opacity:var(--opacity-5)}.ap-tag.ap-tag-disabled .ap-tag-label,.ap-tag.ap-tag-disabled .Appkit4-icon,.ap-tag.ap-tag-disabled .Appkit4-icon:hover{cursor:not-allowed}.ap-tag.ap-tag-disabled:not(.ap-tag-outlined) .Appkit4-icon{color:var(--tag-text-color)}.ap-tag.ap-tag-disabled .icon-close-outline{cursor:not-allowed}.ap-tag.ap-tag-disabled.ap-tag-default:not(.ap-tag-outlined){background-color:rgba(var(--tag-background-color))}.ap-tag.ap-tag-disabled:focus{outline:none}.ap-tag.ap-tag-sm{height:1.5rem;font-size:.875rem;display:inline-flex;font-weight:var(--font-weight-1);padding:var(--spacing-2) var(--spacing-3)}.ap-tag.ap-tag-sm .Appkit4-icon{width:.75rem;height:1rem}.ap-tag.ap-tag-sm .Appkit4-icon:before{font-size:.75rem;font-weight:var(--font-weight-2);line-height:1rem;letter-spacing:normal}.ap-tag.ap-tag-sm .ap-tag-label{font-size:.875rem;line-height:1rem}.ap-tag.ap-tag-lg{height:2rem;font-size:1rem;display:inline-flex;font-weight:var(--font-weight-2)}.ap-tag.ap-tag-lg .Appkit4-icon{width:.75rem;height:1rem}.ap-tag.ap-tag-lg .Appkit4-icon:before{font-weight:var(--font-weight-2);font-size:.75rem;line-height:1rem;letter-spacing:normal}.ap-tag.ap-tag-lg .ap-tag-label{font-size:1rem;font-weight:var(--font-weight-2)}.ap-tag .ap-tag-label{margin-right:var(--spacing-3);letter-spacing:-.025rem}.ap-tag.ap-tag-single .ap-tag-label{margin-right:0}.ap-tag.ap-tag-outlined{border:.0625rem solid var(--tag-border-color)}.ap-tag.ap-tag-outlined .Appkit4-icon{color:var(--tag-icon-color)}.ap-tag .Appkit4-icon{color:var(--tag-text-color);cursor:pointer;z-index:1}.ap-tag .Appkit4-icon:hover{cursor:pointer}.ap-tag .Appkit4-icon.button-outlined{color:var(--tag-icon-color)}.ap-tag.ap-tag-default:not(.ap-tag-disabled):not(.ap-tag-outlined){background:rgba(var(--tag-background-color));color:var(--tag-text-color)}.ap-tag.ap-tag-default:not(.ap-tag-disabled):not(.ap-tag-outlined):hover:after{background-color:rgba(255,255,255,var(--opacity-3));content:\"\";height:100%;width:100%;position:absolute;bottom:0;left:0;border-radius:inherit}.ap-tag.ap-tag-default.ap-tag-outlined:not(.ap-tag-disabled):hover{background:rgba(var(--tag-background-color),var(--opacity-4))}.ap-tag.ap-tag-default.ap-tag-outlined:not(.ap-tag-disabled):active,.ap-tag.ap-tag-default.ap-tag-outlined:not(.ap-tag-disabled):visited{background:rgba(var(--tag-background-color),var(--opacity-6))}.ap-tag.ap-tag-default.ap-tag-outlined{background:rgba(var(--tag-background-color),var(--opacity-3));color:var(--tag-text-color);border:.0625rem solid var(--tag-border-color)}::ng-deep [data-keyboard-focus=true] .ap-tag.ap-tag-default:not(.ap-tag-disabled):focus{box-shadow:0 0 0 .25rem rgba(var(--tag-background-color),var(--opacity-1))!important;outline:auto .125rem Highlight!important;outline:auto .3125rem -webkit-focus-ring-color!important;outline-offset:var(--spacing-1)!important}::ng-deep :not([data-keyboard-focus=true]) .ap-tag.ap-tag-default:not(.ap-tag-disabled):focus{outline:none!important}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: TagComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ap-tag', template: `
              <div #apTag class="ap-tag ap-tag-default {{styleClass}}"
                  [attr.tabindex]="disabled || showClose ? -1 : tabindex"
                  [attr.disabled]="disabled"
                  [attr.aria-label]="text"
                  [attr.id]="inputId"
                  [attr.aria-label]="ariaLabel"
                  [attr.aria-disabled]="disabled"
                  [class.ap-tag-disabled]="disabled"
                  [ngClass]="{'ap-tag-sm':size==='small', 'ap-tag-lg':size==='large', 'ap-tag-outlined':type==='outlined','ap-tag-single':!showClose}"
                  [ngStyle]="inlineSytle"
                  (keydown)="onKeydown($event, text)"
              >
                <span [attr.title]="text" class="ap-tag-label"  *ngIf="text">{{ text }}</span>
                <button *ngIf="showClose" role="button" (click)="!disabled && closeTag($event, text)" type="button"  [attr.aria-description]="text" [attr.aria-label]="getAriaLabel('clear')" [attr.aria-disabled]="disabled" [disabled]="disabled" [style]="iconStyle" class="Appkit4-icon icon-circle-delete-fill"></button>
              </div>
            `, styles: [".ap-tag{position:relative;display:inline-block;padding:var(--spacing-2) var(--spacing-4);border-radius:1rem;line-height:1rem;letter-spacing:-.025rem;color:var(--color-text-tertiary);align-items:center;justify-content:space-between;-webkit-user-select:none;user-select:none}.ap-tag:after{border-radius:1rem}.ap-tag.ap-tag-disabled{cursor:not-allowed;opacity:var(--opacity-5)}.ap-tag.ap-tag-disabled .ap-tag-label,.ap-tag.ap-tag-disabled .Appkit4-icon,.ap-tag.ap-tag-disabled .Appkit4-icon:hover{cursor:not-allowed}.ap-tag.ap-tag-disabled:not(.ap-tag-outlined) .Appkit4-icon{color:var(--tag-text-color)}.ap-tag.ap-tag-disabled .icon-close-outline{cursor:not-allowed}.ap-tag.ap-tag-disabled.ap-tag-default:not(.ap-tag-outlined){background-color:rgba(var(--tag-background-color))}.ap-tag.ap-tag-disabled:focus{outline:none}.ap-tag.ap-tag-sm{height:1.5rem;font-size:.875rem;display:inline-flex;font-weight:var(--font-weight-1);padding:var(--spacing-2) var(--spacing-3)}.ap-tag.ap-tag-sm .Appkit4-icon{width:.75rem;height:1rem}.ap-tag.ap-tag-sm .Appkit4-icon:before{font-size:.75rem;font-weight:var(--font-weight-2);line-height:1rem;letter-spacing:normal}.ap-tag.ap-tag-sm .ap-tag-label{font-size:.875rem;line-height:1rem}.ap-tag.ap-tag-lg{height:2rem;font-size:1rem;display:inline-flex;font-weight:var(--font-weight-2)}.ap-tag.ap-tag-lg .Appkit4-icon{width:.75rem;height:1rem}.ap-tag.ap-tag-lg .Appkit4-icon:before{font-weight:var(--font-weight-2);font-size:.75rem;line-height:1rem;letter-spacing:normal}.ap-tag.ap-tag-lg .ap-tag-label{font-size:1rem;font-weight:var(--font-weight-2)}.ap-tag .ap-tag-label{margin-right:var(--spacing-3);letter-spacing:-.025rem}.ap-tag.ap-tag-single .ap-tag-label{margin-right:0}.ap-tag.ap-tag-outlined{border:.0625rem solid var(--tag-border-color)}.ap-tag.ap-tag-outlined .Appkit4-icon{color:var(--tag-icon-color)}.ap-tag .Appkit4-icon{color:var(--tag-text-color);cursor:pointer;z-index:1}.ap-tag .Appkit4-icon:hover{cursor:pointer}.ap-tag .Appkit4-icon.button-outlined{color:var(--tag-icon-color)}.ap-tag.ap-tag-default:not(.ap-tag-disabled):not(.ap-tag-outlined){background:rgba(var(--tag-background-color));color:var(--tag-text-color)}.ap-tag.ap-tag-default:not(.ap-tag-disabled):not(.ap-tag-outlined):hover:after{background-color:rgba(255,255,255,var(--opacity-3));content:\"\";height:100%;width:100%;position:absolute;bottom:0;left:0;border-radius:inherit}.ap-tag.ap-tag-default.ap-tag-outlined:not(.ap-tag-disabled):hover{background:rgba(var(--tag-background-color),var(--opacity-4))}.ap-tag.ap-tag-default.ap-tag-outlined:not(.ap-tag-disabled):active,.ap-tag.ap-tag-default.ap-tag-outlined:not(.ap-tag-disabled):visited{background:rgba(var(--tag-background-color),var(--opacity-6))}.ap-tag.ap-tag-default.ap-tag-outlined{background:rgba(var(--tag-background-color),var(--opacity-3));color:var(--tag-text-color);border:.0625rem solid var(--tag-border-color)}::ng-deep [data-keyboard-focus=true] .ap-tag.ap-tag-default:not(.ap-tag-disabled):focus{box-shadow:0 0 0 .25rem rgba(var(--tag-background-color),var(--opacity-1))!important;outline:auto .125rem Highlight!important;outline:auto .3125rem -webkit-focus-ring-color!important;outline-offset:var(--spacing-1)!important}::ng-deep :not([data-keyboard-focus=true]) .ap-tag.ap-tag-default:not(.ap-tag-disabled):focus{outline:none!important}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1.LocalizationConfig }, { type: i2.FocusIndicatorService }], propDecorators: { type: [{
                type: Input
            }], size: [{
                type: Input
            }], text: [{
                type: Input
            }], tabindex: [{
                type: Input
            }], inputId: [{
                type: Input
            }], disabled: [{
                type: Input
            }], showClose: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], style: [{
                type: Input
            }], backgroundColor: [{
                type: Input
            }], fontColor: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], onClose: [{
                type: Output
            }], apTag: [{
                type: ViewChild,
                args: ['apTag']
            }] } });
class TagModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: TagModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.11", ngImport: i0, type: TagModule, declarations: [TagComponent], imports: [CommonModule], exports: [TagComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: TagModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: TagModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [TagComponent],
                    declarations: [TagComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TagComponent, TagModule };
